import React from 'react'
import {SubHeroText} from './Styles'
import { Link } from 'react-router-dom'
function Projects() {
    return (
        <div class="content-wrapper projects-container">
            <div class="container-flex px-5">
                <div class="row bg-light px-3 py-5 opacity-90">
                    <SubHeroText>
                        FEATURED PROJECTS
                    </SubHeroText>
                <div class="row my-5">
                <div class="table-responsive ">
                <table class="table h5 table-hover">
                <thead>
                    <tr>
                    <th>Title</th>
                    <th>Description</th>
                    <th>Language</th>
                    <th>Date</th>
                    <th>Links</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Spintrip</td>
                    <td>Meet your perfect car for the holiday. Rent, host and relax.</td>
                    <td>ReactJS</td>
                    <td>Ongoing</td>
                    <td>Private</td>
                    </tr>
                    <tr>
                    <td>VEAR.AI</td>
                    <td>Fashion apparel one-stop solution with curated designs specially for you, powered by our AI.</td>
                    <td>ReactJS/Python/DevOps</td>
                    <td>Ongoing</td>
                    <td>Private</td>
                    </tr>
                    <tr>
                    <td>Krypton</td>
                    <td>Crypto based website using CoinMarketCap and RapidAPI website API’s along with React-Redux. Django as backend.</td>
                    <td>Javascript/Python</td>
                    <td>12/31/2022</td>
                    <td><a class="text-decoration-underline" target='_blank' href="https://krypton-encrypted.netlify.app/">Link</a></td>
                    </tr>
                    <tr>
                    <td>Anomaly Detection</td>
                    <td>Using advanced Machine Learning techniques tracking of any sort of Anomaly. </td>
                    <td>Python</td>
                    <td>12/03/2020</td>
                    <td><a class="text-decoration-underline" target='_blank' href="">Link</a></td>

                    </tr>
                    <tr>
                    <td>Tesla Clone</td>
                    <td>ReactJS website with UI and transitions at peak effeciency.</td>
                    <td>Javascript</td>
                    <td>06/16/2021</td>
                    <td><a class="text-decoration-underline" target='_blank' href="">Link</a></td>

                    </tr>
                    
                </tbody>
                </table>
                </div>
                </div>
                <div class="row my-1">
                    <SubHeroText>
                        Future Ventures(Teach myself in 2024)
                    </SubHeroText>
                    <p class="h5 my-3 mx-3">
                        <li class="my-2">Scalable System Architecture</li>
                        <li class="my-2">Advance Machine Learning/AI</li>
                        <li class="my-2">Data Security</li>
                        <li class="my-2">Selenium GRID</li>
                        <li class="my-2">Competetive Porgramming</li>
                        <li class="my-2">Toasting bread instantly</li>
                    </p>
                </div>
                <div class="row w-full">
                    <div  class="col  d-flex align-items-center justify-content-center w-100 mt-5">
                    <h6 class="fw-bold">
                        I have many interests besides technology that I may share in a similar approach. You can read more about my technology stack on the software page. 
                    </h6>
                    </div>
                    <div class="row mt-5  w-full">
                        <div class="col d-flex flex-col md:flex-row align-items-center justify-content-center">
                            
                            <div class="m-2">
                            <Link to={'/contact'}>
                                <button class="bg-gray-900 hover:bg-gray-800 text-white font-bold py-2 px-4 rounded">
                                    
                                    Contact
                                    
                                    
                                </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

export default Projects
